import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModSessionTokenState {
  modSessionToken: null | number;
}

const initialState: ModSessionTokenState = {
  modSessionToken: null,
};

const modSessionTokenSlice = createSlice({
  name: "modSessionToken",
  initialState,
  reducers: {
    setModCSPDCLSessionToken: (state, action: PayloadAction<number>) => {
      state.modSessionToken = action.payload;
    },
    clearModSessionToken: (state) => {
      state.modSessionToken = null;
    },
  },
});

export const { setModCSPDCLSessionToken, clearModSessionToken } = modSessionTokenSlice.actions;
export default modSessionTokenSlice.reducer;
